import script from "./NotificationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBlock.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBlock.vue?vue&type=style&index=0&id=b47a5158&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b47a5158"]])

export default __exports__